import { useConvexAuth } from "convex/react";
import { Navigate } from "@tanstack/react-router";
import type { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

import { useBackendAvailability } from "./backendAvailability";
import { ProfileGate } from "../features/profile/ProfileGate";
import { AccessState } from "../design-system/AccessState";

function ConnectedAppAccess({ children }: PropsWithChildren) {
  const { t } = useTranslation("account");
  const { isAuthenticated, isLoading } = useConvexAuth();

  if (isLoading) {
    return (
      <AccessState
        description={t("auth.loadingDescription")}
        state="loading"
        title={t("auth.loading")}
      />
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth" />;
  }

  return <ProfileGate>{children}</ProfileGate>;
}

export function AppAccess({ children }: PropsWithChildren) {
  const backendAvailable = useBackendAvailability();
  return backendAvailable ? <ConnectedAppAccess>{children}</ConnectedAppAccess> : children;
}
